// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionWhatsIncluded_root__1aPV2","header":"SectionWhatsIncluded_header__iV-qX","totalDivider":"SectionWhatsIncluded_totalDivider__1wcYK"};